import { render, staticRenderFns } from "./tab_highlight_post.vue?vue&type=template&id=90949f7a&scoped=true"
import script from "./tab_highlight_post.vue?vue&type=script&lang=js"
export * from "./tab_highlight_post.vue?vue&type=script&lang=js"
import style0 from "./tab_highlight_post.vue?vue&type=style&index=0&id=90949f7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90949f7a",
  null
  
)

export default component.exports